import { Text } from "@chakra-ui/react";
import { StatesMachine } from "components/pipeline-components/classes/state-machine/state-machine";
import { DiagnosticPanel } from "./DiagnosticPanel";

export function EnviaAtendimentoEditor({
  selectedStateId,
  pipelineData,
  diagnosticUpdatePipelineData
}: {
  selectedStateId?: number;
  pipelineData?: StatesMachine;
  diagnosticUpdatePipelineData?: (
    updater: (draft: StatesMachine) => StatesMachine | void
  ) => void;
}) {
  return (
    <>
      <Text color="#90a1b9" fontWeight="600" fontSize="sm">
        Este bloco envia os registros processados para a área de Atendimento do
        PowerHub, permitindo que a base fique disponível para atuação
        operacional/comercial pela equipe responsável.
      </Text>
      {selectedStateId != null &&
        pipelineData &&
        diagnosticUpdatePipelineData && (
          <DiagnosticPanel
            selectedStateId={selectedStateId}
            pipelineData={pipelineData}
            operation="ENVIA_ATENDIMENTO"
            updatePipelineData={diagnosticUpdatePipelineData}
          />
        )}
    </>
  );
}
